import type {SVGProps} from 'react'
import {useId} from 'react'
const SizePassportIcon = (props: SVGProps<SVGSVGElement>) => {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '')
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      width="1em"
      height="1em"
      overflow="visible"
      style={{
        display: 'block',
      }}
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Outline">
        <g id="Intersect">
          <path
            d="M16.175 1.19976L16.6249 0C17.5888 0.0173395 18.2498 0.984325 17.9095 1.89134L13.6377 13.0913C13.4327 13.6378 12.9108 13.9998 12.3268 13.9998H11.375L11.825 12.7998H12.1224C12.3299 12.7998 12.5157 12.6716 12.5896 12.4777L16.6986 1.68795C16.7874 1.45143 16.611 1.19976 16.3584 1.19976H16.175Z"
            fill="var(--fill-0, #D9D9D9)"
          />
          <path
            d="M16.175 1.19976L16.6249 0C17.5888 0.0173395 18.2498 0.984325 17.9095 1.89134L13.6377 13.0913C13.4327 13.6378 12.9108 13.9998 12.3268 13.9998H11.375L11.825 12.7998H12.1224C12.3299 12.7998 12.5157 12.6716 12.5896 12.4777L16.6986 1.68795C16.7874 1.45143 16.611 1.19976 16.3584 1.19976H16.175Z"
            fill={`url(#${uid}paint0_linear_13120_20401)`}
          />
        </g>
        <g id="Intersect_2">
          <path
            d="M13.0496 13.7989L12.5706 12.5213C12.487 12.6906 12.3139 12.7998 12.1224 12.7998H1.63689C1.42685 12.7998 1.28183 12.5895 1.35647 12.3932L1.77213 11.2998H0.489896L0.0778684 12.3776C0.0247574 12.5188 0 12.6617 0 12.8012C0 13.4366 0.51405 13.9998 1.2019 13.9998H12.3268C12.5877 13.9998 12.8362 13.9275 13.0496 13.7989Z"
            fill="var(--fill-0, #D9D9D9)"
          />
          <path
            d="M13.0496 13.7989L12.5706 12.5213C12.487 12.6906 12.3139 12.7998 12.1224 12.7998H1.63689C1.42685 12.7998 1.28183 12.5895 1.35647 12.3932L1.77213 11.2998H0.489896L0.0778684 12.3776C0.0247574 12.5188 0 12.6617 0 12.8012C0 13.4366 0.51405 13.9998 1.2019 13.9998H12.3268C12.5877 13.9998 12.8362 13.9275 13.0496 13.7989Z"
            fill={`url(#${uid}paint1_linear_13120_20401)`}
          />
        </g>
        <g id="Intersect_3">
          <path
            d="M17.5028 0.329907L16.6899 1.41367C16.634 1.29035 16.51 1.2 16.3586 1.2H5.88755C5.72147 1.2 5.57282 1.30262 5.51381 1.45786L5.19367 2.3H3.93066L4.48781 0.842611C4.67847 0.335701 5.16361 0 5.70551 0H16.5987C16.9501 0 17.2626 0.126001 17.5028 0.329907Z"
            fill="var(--fill-0, #D9D9D9)"
          />
          <path
            d="M17.5028 0.329907L16.6899 1.41367C16.634 1.29035 16.51 1.2 16.3586 1.2H5.88755C5.72147 1.2 5.57282 1.30262 5.51381 1.45786L5.19367 2.3H3.93066L4.48781 0.842611C4.67847 0.335701 5.16361 0 5.70551 0H16.5987C16.9501 0 17.2626 0.126001 17.5028 0.329907Z"
            fill={`url(#${uid}paint2_linear_13120_20401)`}
          />
        </g>
        <path id="Vector" d="M6.8 6.40039H0V6.90039H6.8V6.40039Z" fill="var(--fill-0, #2D2E2C)" />
        <path id="Vector_2" d="M6 8.90039H1V9.40039H6V8.90039Z" fill="var(--fill-0, #2D2E2C)" />
        <path
          id="Vector_3"
          d="M7.40039 3.90039H2.40039V4.40039H7.40039V3.90039Z"
          fill="var(--fill-0, #2D2E2C)"
        />
      </g>
      <defs>
        <linearGradient
          id={`${uid}paint0_linear_13120_20401`}
          x1={17.0458}
          y1={0.590532}
          x2={12.2882}
          y2={13.3863}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B64A" />
          <stop offset={1} stopColor="#DC9F1C" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint1_linear_13120_20401`}
          x1={-9.05854e-10}
          y1={12.7726}
          x2={12.0771}
          y2={12.7337}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E42922" />
          <stop offset={1} stopColor="#DC9F1C" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint2_linear_13120_20401`}
          x1={4.95693}
          y1={1.46001}
          x2={16.5933}
          y2={1.54265}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2085CE" />
          <stop offset={1} stopColor="#58B64A" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export {SizePassportIcon}
